import { Result } from '../Result/index.js';
export class Storage {
    type;
    storage;
    constructor(type) {
        this.type = type;
        this.storage =
            this.type === 'local'
                ? globalThis.localStorage
                : globalThis.sessionStorage;
    }
    get length() {
        return this.storage.length;
    }
    get = (key) => {
        return this.storage.getItem(key) ?? undefined;
    };
    set = (key, value) => {
        return Result.try({
            try: () => {
                this.storage.setItem(key, value);
            },
            catch: (error) => error,
        });
    };
    clear = () => {
        return Result.try({
            try: () => {
                this.storage.clear();
            },
            catch: (error) => error,
        });
    };
    delete = (key) => {
        return Result.try({
            try: () => {
                this.storage.removeItem(key);
            },
            catch: (error) => error,
        });
    };
}
export const localStorage = new Storage('local');
export const sessionStorage = new Storage('session');
//# sourceMappingURL=storage.js.map